import { Alert } from '../types';
export default function useAlert(options) {
    if (options === void 0) { options = {}; }
    var fetch = options.fetch;
    return new Alert(fetch);
}
